import { Component, Input, OnInit, signal } from '@angular/core';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { BaseLogoCarouselComponent } from './base-logo-carousel/base-logo-carousel.component';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-c-logo-carousel',
  imports: [
    SHeaderComponent,
    BaseLogoCarouselComponent,
    CommonModule
  ],
  templateUrl: './c-logo-carousel.component.html',
  styleUrl: './c-logo-carousel.component.scss'
})
export class CLogoCarouselComponent extends CBaseComponent implements OnInit {

  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader, ElementsType.LogoCarouselConfig];
    console.log('CLogoCarouselComponent ngOnInit - singleLabels:', this.singleLabels);
    super.ngOnInit();
  }
}
